// FAQ text only — edit questions and answers here; no other code needs to change.
const faqCategories = [
  {
    "title": "Getting Started",
    "items": [
      {
        "q": "What is Morphosys?",
        "a": "Morphosys is an online screenwriting and creative production platform that brings screenplay writing, character development, storyboarding and AI-assisted visualisation together in one workspace."
      },
      {
        "q": "Who is Morphosys designed for?",
        "a": "Morphosys is designed for screenwriters, filmmakers, television creators, production companies, advertising professionals, students and educators."
      },
      {
        "q": "Do I need to install software?",
        "a": "No. Morphosys works through a web browser on desktop, laptop and mobile devices. You can also add the web app to your device's home screen for convenient access."
      },
      {
        "q": "Is Morphosys suitable for beginners?",
        "a": "Yes. Morphosys includes onboarding guidance that introduces the essential elements of screenplay writing, including Scene Heading, Action, Character and Dialogue."
      },
      {
        "q": "Can I use Morphosys on my phone?",
        "a": "Yes. Morphosys includes a mobile-friendly screenwriting editor, allowing you to continue writing when you're away from your computer."
      }
    ]
  },
  {
    "title": "Screenwriting",
    "items": [
      {
        "q": "What types of scripts can I create?",
        "a": "Morphosys currently supports Treatment, Film, TV and Commercial projects. Commercials use the same screenplay format, with an advertising-style Title Page."
      },
      {
        "q": "Does Morphosys format screenplays automatically?",
        "a": "Yes. The editor supports screenplay formatting elements such as Scene Heading, Action, Character, Dialogue and Parenthetical, helping you maintain a consistent screenplay format."
      },
      {
        "q": "Can I edit a screenplay after saving it?",
        "a": "Yes. You can reopen your saved screenplay at any time and continue writing or editing it."
      },
      {
        "q": "Can I work on several screenplays?",
        "a": "Yes. Your Scripts section allows you to create, access and manage multiple screenplay projects."
      },
      {
        "q": "Can I export my screenplay?",
        "a": "Yes. You can export your screenplay as a PDF for reading, printing or sharing."
      },
      {
        "q": "How does Morphosys calculate screenplay pages?",
        "a": "Morphosys uses its screenwriting editor's pagination system to calculate screenplay pages. The page count is saved with your script and is also used by Script Analysis."
      },
      {
        "q": "Can I change the title of my screenplay?",
        "a": "Yes. You can edit the title-page information for your screenplay after creating it."
      },
      {
        "q": "Do I have to complete the title page before writing?",
        "a": "No. You can begin writing without completing every title-page field and return to those details later."
      }
    ]
  },
  {
    "title": "Characters",
    "items": [
      {
        "q": "Can I create character profiles?",
        "a": "Yes. Morphosys allows you to create character profiles containing names, ages, physical descriptions, hair colour, eye colour and other relevant information."
      },
      {
        "q": "Why should I complete character descriptions?",
        "a": "Character descriptions help Morphosys maintain more consistent appearances when generating AI storyboards and Premium Videos."
      },
      {
        "q": "Can I change character details later?",
        "a": "Yes. You can edit character information as your screenplay develops."
      },
      {
        "q": "Do I have to complete character profiles before writing?",
        "a": "No. Character profiles are optional for writing your screenplay. However, completing them can improve visual consistency when using AI tools."
      },
      {
        "q": "Can I describe what a character is wearing in a particular scene?",
        "a": "Yes. Storyboard provides options for scene-specific appearance and wardrobe information, allowing you to describe changes that apply to an individual scene."
      }
    ]
  },
  {
    "title": "AI Features",
    "items": [
      {
        "q": "What AI tools are available in Morphosys?",
        "a": "Morphosys includes Ideas, Scene Analysis, Script Analysis, Storyboard, AI Video and Premium Video."
      },
      {
        "q": "Will Morphosys AI rewrite my screenplay?",
        "a": "No. The AI analysis tools are designed to offer feedback and creative suggestions without automatically replacing or rewriting your original screenplay."
      },
      {
        "q": "What is Ideas?",
        "a": "Ideas helps writers explore and develop creative possibilities for their stories, characters and screenplay concepts."
      },
      {
        "q": "What is Scene Analysis?",
        "a": "Scene Analysis reviews a selected screenplay scene and provides feedback on its storytelling and dramatic elements."
      },
      {
        "q": "What is Script Analysis?",
        "a": "Script Analysis reviews a screenplay and provides creative feedback to help writers evaluate and develop their work."
      },
      {
        "q": "How does Script Analysis determine the length of my screenplay?",
        "a": "Morphosys uses the screenplay's saved page count to identify it as a Short, Medium or Long Script. You can see this information before starting an analysis."
      },
      {
        "q": "What is Storyboard?",
        "a": "Storyboard generates visual frames from a selected screenplay scene, helping writers and filmmakers explore how the scene might appear on screen."
      },
      {
        "q": "Can I customise my storyboard?",
        "a": "Yes. You can choose visual styles, adjust shot types, specify camera directions and provide scene-specific appearance information."
      },
      {
        "q": "How does Morphosys keep characters consistent in storyboards?",
        "a": "Morphosys uses saved character descriptions and scene-specific appearance information to guide image generation. Some visual variation may still occur because the images are AI-generated."
      },
      {
        "q": "What is AI Video?",
        "a": "AI Video turns a saved storyboard image into a short moving video. It helps visualise character movement, camera action and the atmosphere of a scene. Video generation is currently available to authorised testers and will become available more widely when released."
      },
      {
        "q": "What is Premium Video?",
        "a": "Premium Video generates a short cinematic video directly from your screenplay, including character movement, spoken dialogue, natural sound and synchronised mouth movements. Video generation is currently available to authorised testers and will become available more widely when released."
      },
      {
        "q": "What video lengths are available in Premium Video?",
        "a": "Premium Video offers 10-second and 30-second videos."
      },
      {
        "q": "Do I need to create a storyboard before using Premium Video?",
        "a": "No. Premium Video generates directly from the screenplay's original action, character descriptions and dialogue."
      },
      {
        "q": "Will Premium Video use my original dialogue?",
        "a": "Premium Video is designed to reproduce the dialogue written in your screenplay. Morphosys checks generated speech against the original dialogue, although occasional differences in pronunciation, timing or delivery may occur."
      },
      {
        "q": "Will the characters' mouths match their dialogue?",
        "a": "Premium Video uses AI-generated lip-sync to coordinate mouth movements with spoken dialogue. Results may vary slightly depending on the scene and characters."
      },
      {
        "q": "Will my characters look the same throughout the video?",
        "a": "Morphosys uses character descriptions and visual references to encourage consistent appearances. AI generation may still produce small variations in facial appearance, clothing or movement."
      },
      {
        "q": "Can AI-generated videos contain small pauses or transitions?",
        "a": "Yes. Premium Video may combine several shorter generated clips into one finished video. Small changes in movement, voice or background sound may occasionally be noticeable between clips."
      },
      {
        "q": "Can I use the AI tools without changing my screenplay?",
        "a": "Yes. The AI tools help you explore, analyse and visualise your work without automatically altering the screenplay stored in your account."
      }
    ]
  },
  {
    "title": "Saving, Downloading and Deleting",
    "items": [
      {
        "q": "Are my screenplays saved?",
        "a": "Yes. Morphosys saves screenplay information to your account so you can return and continue working."
      },
      {
        "q": "Can I download my screenplay?",
        "a": "Yes. Screenplays can be exported as PDF documents."
      },
      {
        "q": "Can I download my storyboards?",
        "a": "Yes. Morphosys provides options to download generated storyboard images and storyboard PDFs."
      },
      {
        "q": "Can I download my AI-generated videos?",
        "a": "Yes. Completed videos can be downloaded as MP4 files. Videos containing audio include the generated soundtrack and dialogue."
      },
      {
        "q": "Where do I find my saved storyboards and videos?",
        "a": "Saved results are available within their respective Storyboard, AI Video or Premium Video sections."
      },
      {
        "q": "How long are generated storyboards and videos stored?",
        "a": "AI-generated storyboard images and videos are currently retained for up to 120 days. Download any media you wish to keep before its storage period expires."
      },
      {
        "q": "Can I delete a Premium Video?",
        "a": "Yes. You can delete a saved Premium Video after confirming the action. Morphosys removes the associated media from cloud storage while retaining necessary usage and accounting records."
      },
      {
        "q": "What happens if video generation fails?",
        "a": "AI video generation may occasionally fail because of provider limitations. Morphosys displays the failure status. When no usable completed video is delivered, the credits used for that attempt are returned."
      },
      {
        "q": "Can I access my saved scripts from another device?",
        "a": "Yes. Sign in to the same Morphosys account to access your saved screenplay projects from another supported device."
      }
    ]
  },
  {
    "title": "Collaboration and Support",
    "items": [
      {
        "q": "Can I share my screenplay with another person?",
        "a": "Yes. Morphosys includes script-sharing and invitation features, subject to the permissions available to your account."
      },
      {
        "q": "Can I invite someone to collaborate?",
        "a": "Morphosys provides invitation options to help users work with others on screenplay projects."
      },
      {
        "q": "Is Morphosys suitable for production companies?",
        "a": "Yes. Morphosys is designed for individual creatives as well as professional filmmaking and production environments."
      },
      {
        "q": "Can students and film schools use Morphosys?",
        "a": "Yes. Morphosys supports screenwriting education and creative development for students and educators."
      },
      {
        "q": "Where can I update my personal information?",
        "a": "You can manage your account details through the Profile section of Morphosys."
      },
      {
        "q": "How do I get help with a problem?",
        "a": "Use the existing Morphosys support or contact option to request help or report an issue."
      }
    ]
  }
]

export default faqCategories
